export const vhToPixels = (vh = 100) => Math.round(window.innerHeight / (100 / vh))
